import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "pt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "pb-2 border-b" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-3/4 text-left" }, " Your Nominations ")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "No one that you have invited have joined ReGrok yet. When they do, you will see them here.", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.usersLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading... "))
      : ($setup.usersQueryError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Error: " + _toDisplayString($setup.usersQueryError.message), 1))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        ($setup.users == undefined || $setup.users?.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (user) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: user.username,
            "data-test-id": "user-list"
          }, [
            _createElementVNode("td", {
              class: "w-auto truncate mr-2",
              "aria-label": user.username
            }, [
              _createElementVNode("a", {
                onClick: ($event: any) => ($setup.viewUser(user.username))
              }, _toDisplayString(user.username) + " - " + _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 9, _hoisted_9)
            ], 8, _hoisted_8)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}